module.exports = __webpack_public_path__ + "img/consumption_orange.62fdab93.png";